import React, {
  useState,
  useCallback,
  useEffect,
  useMemo,
  useRef,
} from "react";
import {
  Card,
  TextContainer,
  TextField,
  ButtonGroup,
  PageActions,
  FormLayout,
  Select,
  Page,
  Button,
  Modal,
  List,
  Text,
  Toast,
  Loading,
  Layout,
  DropZone,
  InlineStack,
  Thumbnail,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import MenusDraggableNestedList from "../../Components/MenusDraggableNestedList";
import {
  SearchMinor,
  LanguageIcon,
  PageIcon,
  LinkIcon,
  MobileHamburgerMajor,
  CollectionFilledIcon,
  ProductsMajor,
} from "@shopify/polaris-icons";
import { useParams } from "react-router-dom";
import { ChannelsModal } from "./ChannelsModal";
import LoadingScreen from "../../Components/LoadingScreen";
import AsyncSelect from "react-select/async";

const EditMenu = (props) => {
  const ref = useRef("");
  const refModalType = useRef("");
  const refId = useRef(null);
  const { id } = useParams();
  const [ts, setTs] = useState("");
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [activeAddItem, setActiveAddItem] = useState(false);
  const handleChangeAddItem = useCallback(
    () => setActiveAddItem(!activeAddItem),
    [activeAddItem]
  );
  const [isSaving, setIsSaving] = useState(true);

  const handleChangeTitle = (newValue) => {
    setItem({ ...item, title: newValue });
  };

  const [selectedLinkType, setSelectedLinkType] = useState("");

  const handleSelectChangeLinkType = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, linkType: value };
      }
      return obj;
    });
    setData(newState);
  };
  const optionsLinkType = [
    { label: "Pages", value: "1" },
    { label: "External Link", value: "3" },
    { label: "Menu", value: "6" },
    { label: "Shopify Collection", value: "4" },
    { label: "Shopify Product", value: "5" },
    { label: "None", value: "7" },
  ];

  const [optionsPages, setOptionsPages] = useState([]);
  const [optionsMenus, setOptionsMenus] = useState([]);

  const [item, setItem] = useState({
    title: "",
    items: "",
  });
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [optionsLanguages, setOptionsLanguages] = useState("");
  const handleSelectChangeLanguage = (value) => {
    setSelectedLanguage(value);
  };
  const [items, setItems] = useState([]);

  const [activeChannels, setActiveChannels] = useState(false);
  const handleChangeActiveChannels = useCallback(
    () => setActiveChannels(!activeChannels),
    [activeChannels]
  );
  const handleChangeActiveChannelsDone = () => {
    setActiveChannels(false);
    setChannelsToShow(selectedChannels);
  };
  const [channels, setChannels] = useState([]);
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [channelsToShow, setChannelsToShow] = useState([]);
  const handleSelectedChannels = (param) => {
    setSelectedChannels(param);
  };

  useEffect(() => {
    fetchData();
  }, [ts]);
  async function fetchData() {
    let responseLanguages = "";
    // if (!optionsLanguages.length) {
    try {
      responseLanguages = await axios.get(
        `/settings/languages?filter[is_active]=1`
      );
      responseLanguages?.data?.data?.data &&
        setOptionsLanguages(
          responseLanguages.data.data.data.map((item, index) => {
            return {
              label: item.name,
              value: item.code,
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    // }
    let responseMenu = "";
    try {
      responseMenu = await axios.get(`/navigation-lists/${id}`);
      setItem({
        title: responseMenu?.data?.data?.title
          ? responseMenu.data.data.title
          : "",
      });

      responseMenu?.data?.data?.channels &&
        setChannelsToShow(
          responseMenu?.data?.data?.channels.map((item) => item.id)
        );
      setSelectedChannels(
        responseMenu?.data?.data?.channels.map((item) => item.id)
      );
      setData(
        responseLanguages?.data?.data?.data
          .concat([{ label: "English", code: "en" }])
          .map((element, index) => {
            return {
              language: element.code,
              active: 1,
              name: "",
              linkType: "",
              externalLink: "",
              page: "",
              shopifyCollection: "",
              shopifyProduct: "",
              menu: "",
              image: "",
            };
          })
      );

      responseMenu?.data?.data?.items &&
        setItems(
          responseMenu?.data?.data?.items.map((element, index) => {
            return {
              id: String(element.id),
              name: element.title["en"],
              image: element?.image ? element?.image : "",
              element: JSON.stringify(element),
              items: element.sub_items
                ? element.sub_items.map((element, index) => {
                    return {
                      id: String(element.id),
                      name: element.title["en"],
                      image: element?.image ? element?.image : "",
                      element: JSON.stringify(element),
                      parentId: element.parent_id,
                    };
                  })
                : [],
            };
          })
        );
      setIsSaving(false);

      let responsePages = "";
      if (!optionsPages.length) {
        try {
          responsePages = await axios.get(`/pages?per_page=10000`);
          responsePages?.data?.data?.data &&
            setOptionsPages(
              responsePages.data.data.data.map((item, index) => {
                return {
                  label: item.title.en,
                  value: item.alias,
                  key: String(item.id),
                };
              })
            );
        } catch (error) {
          console.log(error);
        }
      }
      let responseMenus = "";
      if (!optionsMenus.length) {
        try {
          responseMenus = await axios.get(`/navigation-lists`);
          responseMenus?.data?.data?.data &&
            setOptionsMenus(
              responseMenus.data.data.data.map((item, index) => {
                return {
                  label: item.title,
                  value: String(item.id),
                  key: String(item.id),
                };
              })
            );
        } catch (error) {
          console.log(error);
        }
      }

      if (!channels.length) {
        try {
          const responseChannels = await axios.get(`/channels`);
          responseChannels?.data?.data?.data &&
            setChannels(
              responseChannels.data.data.data.map((item, index) => {
                return {
                  label: item.name,
                  value: item.id,
                  id: item.id,
                };
              })
            );
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleChangeSubmitAddItem = () => {
    if (!findArrayElementByLanguage(data, "en").name) {
      setNameError("This field is required");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      data.forEach((selected, index) =>
        form_data.append(`title[${selected.language}]`, selected.name)
      );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").linkType === "3" &&
        data.forEach(
          (selected, index) =>
            selected.externalLink &&
            form_data.append(
              `external_link[${selected.language}]`,
              selected.externalLink
            )
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").linkType === "1" &&
        form_data.append(
          "page_alias",
          findArrayElementByLanguage(data, "en") &&
            findArrayElementByLanguage(data, "en").page
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").linkType === "6" &&
        form_data.append(
          "menu_id",
          findArrayElementByLanguage(data, "en") &&
            findArrayElementByLanguage(data, "en").menu
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").linkType === "4" &&
        findArrayElementByLanguage(data, "en").shopifyCollection.value &&
        form_data.append(
          "shopify_collection_id",
          findArrayElementByLanguage(data, "en").shopifyCollection.value
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").linkType === "4" &&
        findArrayElementByLanguage(data, "en").shopifyCollection.value &&
        form_data.append(
          "shopify_collection_handle",
          findArrayElementByLanguage(data, "en").shopifyCollection.handle
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").linkType === "4" &&
        form_data.append(
          "shopify_collection_title",
          findArrayElementByLanguage(data, "en").shopifyCollection.label
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").linkType === "5" &&
        findArrayElementByLanguage(data, "en").shopifyProduct.value &&
        form_data.append(
          "shopify_product_id",
          findArrayElementByLanguage(data, "en").shopifyProduct.value
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").linkType === "5" &&
        findArrayElementByLanguage(data, "en").shopifyProduct.value &&
        form_data.append(
          "shopify_product_handle",
          findArrayElementByLanguage(data, "en").shopifyProduct.handle
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").linkType === "5" &&
        form_data.append(
          "shopify_product_title",
          findArrayElementByLanguage(data, "en").shopifyProduct.label
        );

      findArrayElementByLanguage(data, "en") &&
      findArrayElementByLanguage(data, "en").linkType &&
      findArrayElementByLanguage(data, "en").linkType === "7"
        ? form_data.append("link_type", "")
        : form_data.append(
            "link_type",
            findArrayElementByLanguage(data, "en").linkType
          );

      form_data.append("is_active", 1);
      ref.current !== "parent" &&
        form_data.append("parent_id", ref.current.split("_")[1]);
      refModalType.current !== "add" && form_data.append("_method", "PATCH");
      file && form_data.append("image", imageKey.current);
      let url =
        refModalType.current === "add"
          ? `/navigation-lists/${id}/navigation-item`
          : `/navigation-lists/${id}/navigation-item/${refId.current}`;
      axios
        .post(url, form_data)
        .then((res) => {
          const newState = data.map((obj) => {
            if (obj.language === "en") {
              return { ...obj, name: "" };
            }
            return obj;
          });
          setData(newState);
          setTranslatedButtonClicked(false);
          setIsSaving(false);
          setActiveAddItem(false);
          setTs(+new Date());
          //setSelectedOptionsLink([]);
        })
        .catch(function (error) {
          if (error.response) {
            setToastContent(error.response.data.message);
            toggleActiveToast();
            setIsSaving(false);
          }
        });
    }
  };
  const [activeToast, setActiveToast] = useState(false);
  const [toastContent, setToastContent] = useState("");
  const toggleActiveToast = useCallback(
    () => setActiveToast((activeToast) => !activeToast),
    []
  );
  const toastMarkupToast = activeToast ? (
    <Toast content={toastContent} onDismiss={toggleActiveToast} />
  ) : null;
  const [nameError, setNameError] = useState("");
  const handleChangeName = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, name: value };
      }
      return obj;
    });
    setData(newState);
    setNameError("");
  };
  const handleChangeNameTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, name: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChangeExternalLink = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, externalLink: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangePage = (value) => {
    const newState = data.map((obj) => {
      // if (obj.language === "en") {
      console.log("page=", value);
      return { ...obj, page: value };
      //  }
      return obj;
    });
    setData(newState);
  };
  const handleChangeMenu = (value) => {
    const newState = data.map((obj) => {
      // if (obj.language === "en") {
      return { ...obj, menu: value };
      //  }
      return obj;
    });
    setData(newState);
  };
  const handleChangeExternalLinkTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, externalLink: value };
      }
      return obj;
    });
    setData(newState);
  };
  const [translatedButtonClicked, setTranslatedButtonClicked] = useState(false);
  const handleTranslate = () => {
    setTranslatedButtonClicked(!translatedButtonClicked);
  };
  const handleAddSubitem = (param) => {
    refModalType.current = "add";
    ref.current = `child_${param}`;
    setFile();
    setActiveAddItem(true);
  };

  const [activeDelete, setActiveDelete] = useState(false);

  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`navigation-lists/${id}/navigation-item/${refId.current}`)
      .then((result) => {
        // toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const handleUpdateOrder = (array, type, dragStyle) => {
    // const bodyObj = {
    //   ids: array.map((item) => item.id),
    console.log("type=", type);
    // };
    let bodyObj = "";
    if (type === "parents") {
      bodyObj = {
        list: [{ parent_id: null, ids: array.map((item) => item.id) }],
      };
    } else {
      if (dragStyle === "dagChildToAnotherParent") {
        let bigArray = [];
        for (var i = 0; i < array.length; i++) {
          let object = {
            parent_id: array[i].id,
            ids: array[i].items.map((item) => item.id),
          };
          bigArray.push(object);
        }
        console.log("bigArray=", bigArray);
        bodyObj = {
          list: bigArray,
        };
      } else {
        bodyObj = {
          list: [
            { parent_id: array[0].parentId, ids: array.map((item) => item.id) },
          ],
        };
      }
    }
    // const bodyObj = {
    //   list: [
    //     ...(type === "parents" && {
    //       parent_id: null,
    //       ids: array.map((item) => item.id),
    //     }),
    //   ],
    // };
    // const bodyObj = {
    //   list: [
    //     ...(type === "parents" && {
    //       parent_id: null,
    //       ids: array.map((item) => item.id),
    //     }),
    //     // ...(type === "childs" && {
    //     //   parent_id: array[0].parent_id,
    //     //   ids: array.map((item) => item.id),
    //     // }),
    //   ],
    // };
    // const form_data = new FormData();
    // let ids = array.map((item) => item.id);
    // console.log(array.map((item) => item.id));
    // form_data.append("ids", [1, 2, 3]);
    axios
      .post(`navigation-lists/${id}/navigation-item/sort`, bodyObj)
      .then((result) => {
        //setToastContent("Items order have been changed successfully");
        //toggleActiveToast();
        //setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };

  const handleEditMenuItem = (param, id, type) => {
    setFile();
    refId.current = id;
    ref.current = type;
    let object = JSON.parse(param);
    ref.current = `parent`;
    refModalType.current = "edit";
    console.log(JSON.parse(param));

    // setSelectedLinkType(String(object.link_type));
    // String(object.link_type) === "4" &&
    //   setShopifyCollection({
    //     label: object?.title && object?.title?.en ? object?.title?.en : "",
    //     value:
    //       object?.shopify_collection_id !== null
    //         ? object?.shopify_collection_id
    //         : "",
    //     handle: object?.shopify_collection_handle
    //       ? object?.shopify_collection_handle
    //       : "",
    //   });

    setData(
      optionsLanguages
        .concat([{ label: "English", value: "en" }])
        .map((element, index) => {
          return {
            language: element.value,
            active: 1,
            name: object.title[element.value]
              ? object.title[element.value]
              : "",
            linkType: object.link_type !== null ? String(object.link_type) : "",
            externalLink: object.external_link[element.value]
              ? object.external_link[element.value]
              : "",
            page: object.page_alias ? object.page_alias : "",
            shopifyCollection: {
              label: object?.shopify_collection_title
                ? object?.shopify_collection_title
                : "",
              value:
                object?.shopify_collection_id !== null
                  ? object?.shopify_collection_id
                  : "",
              handle: object?.shopify_collection_handle
                ? object?.shopify_collection_handle
                : "",
            },
            shopifyProduct: {
              label: object?.shopify_product_title
                ? object?.shopify_product_title
                : "",
              value:
                object?.shopify_product_id !== null
                  ? object?.shopify_product_id
                  : "",
              handle: object?.shopify_product_handle
                ? object?.shopify_product_handle
                : "",
            },
            menu: object.menu_id !== null ? String(object.menu_id) : "",
            image: object?.image ? object?.image : "",
            // image: object?.details?.image ? object?.details?.image : "",
          };
        })
    );

    setActiveAddItem(true);
  };
  // const handleEditMenuSubItem = (param) => {
  //   ref.current = `child_${param}`;
  //   refId.current = id;
  //   console.log(JSON.parse(param));
  //   let object = JSON.parse(param);
  //   refModalType.current = "edit";
  //   setSelectedOptionsLink(String(object.link_type));
  //   setData(
  //     optionsLanguages
  //       .concat([{ label: "English", value: "en" }])
  //       .map((element, index) => {
  //         return {
  //           language: element.value,
  //           active: 1,
  //           name: object.title[element.value],
  //           linkType: String(object.link_type),
  //           link: object.link[element.value],
  //         };
  //       })
  //   );

  //   setActiveAddItem(true);
  // };
  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );

  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
  ];
  const fileUpload = !file && (
    <DropZone.FileUpload actionHint={"Accepts pngs, jpegs and svgs"} />
  );
  const uploadedFile = file && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* Uncomment if using thumbnail */}
      {/*
    <Thumbnail
      size="small"
      alt={file.name}
      source={
        validImageTypes.includes(file.type)
          ? window.URL.createObjectURL(file)
          : NoteMinor
      }
    />
    */}
      <div>
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </InlineStack>
  );

  const imageKey = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const sendImage = (file) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "navigation");
    form_data.append("image", file[file.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              image:
                validImageTypes.indexOf(file[file.length - 1].type) > 0
                  ? window.URL.createObjectURL(file[file.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [shopifyCollection, setShopifyCollection] = useState("");
  const [
    firstTimeLoadedCollectionsOptions,
    setFirstTimeLoadedCollectionsOptions,
  ] = useState([]);

  const loadOptionsCollections = (inputValue, callback) => {
    axios
      .get(`/shopify-collections?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
                handle: item.handle,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedCollectionsOptions(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: String(item.id),
              handle: item.handle,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };
  const [shopifyProduct, setShopifyProduct] = useState("");

  const [firstTimeLoadedProductsOptions, setFirstTimeLoadedProductsOptions] =
    useState([]);
  const loadOptionsProducts = (inputValue, callback) => {
    axios
      .get(`/shopify-products?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
                handle: item.handle,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedProductsOptions(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: String(item.id),
              handle: item.handle,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };
  const handleSelectChangeShopifyCollection = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, shopifyCollection: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleSelectChangeShopifyProduct = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, shopifyProduct: value };
      }
      return obj;
    });
    setData(newState);
  };
  return (
    <Page
      title="Edit Menu"
      backAction={{
        onAction: () => navigate(`/admin/navigation`),
      }}
    >
      {isSaving ? <Loading /> : null}

      {/* <h1>{JSON.stringify(data)}</h1> */}
      <Layout>
        <Layout.Section>
          <FormLayout>
            <Card sectioned>
              <TextField
                label="Title"
                value={item.title}
                onChange={handleChangeTitle}
                placeholder="e.g. Sidebar menu"
              />
            </Card>
            <Card sectioned title="Menu items">
              <FormLayout>
                <MenusDraggableNestedList
                  items={items}
                  handleAddSubitem={handleAddSubitem}
                  handleDeleteItem={handleDelete}
                  handleUpdateOrder={handleUpdateOrder}
                  handleEditMenuItem={handleEditMenuItem}
                />
                <Button
                  fullWidth
                  primary
                  onClick={() => {
                    refModalType.current = "add";
                    ref.current = "parent";
                    const newState = data.map((obj) => {
                      return {
                        ...obj,
                        name: "",
                        link: "",
                        linkType: "",
                        externalLink: "",
                        page: "",
                        shopifyCollection: "",
                        shopifyProduct: "",
                        menu: "",
                        image: "",
                      };
                    });
                    setData(newState);
                    //setSelectedLinkType("");
                    setActiveAddItem(true);
                    setFile();
                  }}
                >
                  Add Item
                </Button>
              </FormLayout>
            </Card>
          </FormLayout>
        </Layout.Section>
        <Layout.Section secondary>
          <Card
            title="Channels"
            sectioned
            actions={[
              {
                content: "Manage",
                onAction: () => setActiveChannels(true),
              },
            ]}
          >
            {channelsToShow && channelsToShow.length ? (
              <List type="bullet">
                {channelsToShow.map((element, index) => {
                  return (
                    <List.Item key={index}>
                      {findElementByID(channels, element) &&
                        findElementByID(channels, element).label &&
                        findElementByID(channels, element).label}
                    </List.Item>
                  );
                })}
              </List>
            ) : null}
          </Card>
        </Layout.Section>
      </Layout>

      <Modal
        open={activeAddItem}
        large
        onClose={handleChangeAddItem}
        title={`${refModalType.current === "add" ? "Add" : "Edit"} item`}
        primaryAction={{
          content: "Submit",
          onAction: handleChangeSubmitAddItem,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: handleChangeAddItem,
            loading: isSaving,
          },
        ]}
      >
        <Card sectioned>
          <div style={{ float: "right" }}>
            <ButtonGroup>
              <Button
                plain
                onClick={handleTranslate}
                icon={!translatedButtonClicked ? LanguageIcon : ""}
              >
                {translatedButtonClicked ? "Edit English" : "Translate"}
              </Button>
            </ButtonGroup>
          </div>
          <FormLayout>
            <table>
              <tbody>
                <tr>
                  <th>
                    <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
                  </th>
                  <th>
                    <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
                  </th>
                  {translatedButtonClicked && (
                    <th>
                      <Select
                        options={optionsLanguages}
                        onChange={handleSelectChangeLanguage}
                        value={selectedLanguage}
                        placeholder="Please select a language"
                      />
                    </th>
                  )}
                </tr>

                <tr>
                  <td>
                    <Text variant="bodyMd" as="p" color="subdued">
                      Name
                    </Text>
                  </td>
                  <td>
                    <TextField
                      value={
                        findArrayElementByLanguage(data, "en") &&
                        findArrayElementByLanguage(data, "en").name
                          ? findArrayElementByLanguage(data, "en").name
                          : ""
                      }
                      onChange={handleChangeName}
                      disabled={translatedButtonClicked}
                      error={nameError}
                    />
                  </td>
                  {translatedButtonClicked && (
                    <td>
                      <TextField
                        value={
                          findArrayElementByLanguage(data, selectedLanguage)
                            ? findArrayElementByLanguage(data, selectedLanguage)
                                .name
                            : ""
                        }
                        onChange={handleChangeNameTranslated}
                      />
                    </td>
                  )}
                </tr>

                <tr>
                  <td>
                    <Text variant="bodyMd" as="p" color="subdued">
                      Link Type
                    </Text>
                  </td>
                  <td>
                    <Select
                      options={optionsLinkType}
                      onChange={handleSelectChangeLinkType}
                      value={
                        findArrayElementByLanguage(data, "en") &&
                        findArrayElementByLanguage(data, "en").linkType
                      }
                      placeholder="Please select"
                    />

                    {/* <Autocomplete
                      options={optionsLink}
                      selected={selectedOptionsLink}
                      onSelect={updateSelectionLink}
                      textField={textFieldLink}
                    /> */}
                  </td>
                  {/* {translatedButtonClicked && (
                  <td>
                    <Autocomplete
                      options={optionsLink}
                      selected={selectedOptionsLink}
                      onSelect={updateSelectionLink}
                      textField={textFieldLink}
                    />
                  </td>
                )} */}
                </tr>

                {findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").linkType === "3" && (
                    <tr>
                      <td>
                        <Text variant="bodyMd" as="p" color="subdued">
                          Link
                        </Text>
                      </td>
                      <td>
                        <TextField
                          value={
                            findArrayElementByLanguage(data, "en")
                              ? findArrayElementByLanguage(data, "en")
                                  .externalLink
                              : ""
                          }
                          onChange={handleChangeExternalLink}
                          disabled={translatedButtonClicked}
                        />
                      </td>
                      {translatedButtonClicked && (
                        <td>
                          <TextField
                            value={
                              findArrayElementByLanguage(data, selectedLanguage)
                                ? findArrayElementByLanguage(
                                    data,
                                    selectedLanguage
                                  ).externalLink
                                : ""
                            }
                            onChange={handleChangeExternalLinkTranslated}
                          />
                        </td>
                      )}
                    </tr>
                  )}

                {findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").linkType === "1" && (
                    <tr>
                      <td>
                        <Text variant="bodyMd" as="p" color="subdued">
                          Page
                        </Text>
                      </td>
                      <td>
                        <Select
                          label=""
                          options={optionsPages}
                          onChange={handleChangePage}
                          value={
                            findArrayElementByLanguage(data, "en")
                              ? findArrayElementByLanguage(data, "en").page
                              : ""
                          }
                          placeholder="Please select"
                        />
                      </td>
                      {/* {translatedButtonClicked && (
                    <td>
                      <Select
                        label=""
                        options={optionsPages}
                        onChange={handleChangePage}
                        value={
                          findArrayElementByLanguage(data, "en") &&
                          findArrayElementByLanguage(data, "en").link
                        }
                        placeholder="Please select"
                      />
                    </td>
                  )} */}
                    </tr>
                  )}

                {findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").linkType === "6" && (
                    <tr>
                      <td>
                        <Text variant="bodyMd" as="p" color="subdued">
                          Menu
                        </Text>
                      </td>
                      <td>
                        <Select
                          label=""
                          options={optionsMenus}
                          onChange={handleChangeMenu}
                          value={
                            findArrayElementByLanguage(data, "en")
                              ? findArrayElementByLanguage(data, "en").menu
                              : ""
                          }
                          placeholder="Please select"
                        />
                      </td>
                      {/* {translatedButtonClicked && (
                    <td>
                      <Select
                        label=""
                        options={optionsPages}
                        onChange={handleChangePage}
                        value={
                          findArrayElementByLanguage(data, "en") &&
                          findArrayElementByLanguage(data, "en").link
                        }
                        placeholder="Please select"
                      />
                    </td>
                  )} */}
                    </tr>
                  )}

                {findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").linkType === "4" && (
                    <tr>
                      <td>
                        <Text variant="bodyMd" as="p" color="subdued">
                          Shopify Collection
                        </Text>
                      </td>
                      <td>
                        {" "}
                        <AsyncSelect
                          cacheOptions
                          defaultOptions={firstTimeLoadedCollectionsOptions}
                          loadOptions={loadOptionsCollections}
                          onChange={handleSelectChangeShopifyCollection}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          value={
                            findArrayElementByLanguage(data, "en") &&
                            findArrayElementByLanguage(data, "en")
                              .shopifyCollection
                          }
                        />
                        {/* <Autocomplete
                        options={optionsCollections}
                        selected={selectedOptions}
                        onSelect={updateSelection}
                        textField={textField}
                      /> */}
                      </td>
                      {/* {translatedButtonClicked && (
                    <td>
                      <Select
                        label=""
                        options={optionsPages}
                        onChange={handleChangePage}
                        value={
                          findArrayElementByLanguage(data, "en") &&
                          findArrayElementByLanguage(data, "en").link
                        }
                        placeholder="Please select"
                      />
                    </td>
                  )} */}
                    </tr>
                  )}

                {findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").linkType === "5" && (
                    <tr>
                      <td>
                        <Text variant="bodyMd" as="p" color="subdued">
                          Shopify Product
                        </Text>
                      </td>
                      <td>
                        <AsyncSelect
                          cacheOptions
                          defaultOptions={firstTimeLoadedProductsOptions}
                          loadOptions={loadOptionsProducts}
                          onChange={handleSelectChangeShopifyProduct}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          value={
                            findArrayElementByLanguage(data, "en") &&
                            findArrayElementByLanguage(data, "en")
                              .shopifyProduct
                          }
                        />
                        {/* <Autocomplete
                        options={optionsCollections}
                        selected={selectedOptions}
                        onSelect={updateSelection}
                        textField={textField}
                      /> */}
                      </td>
                      {/* {translatedButtonClicked && (
                    <td>
                      <Select
                        label=""
                        options={optionsPages}
                        onChange={handleChangePage}
                        value={
                          findArrayElementByLanguage(data, "en") &&
                          findArrayElementByLanguage(data, "en").link
                        }
                        placeholder="Please select"
                      />
                    </td>
                  )} */}
                    </tr>
                  )}
              </tbody>
            </table>
            <Text as="p" fontWeight="regular">
              Icon
            </Text>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <div style={{ float: "left" }}>
                <Thumbnail
                  size="large"
                  source={
                    findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").image
                  }
                />
              </div>
              <div
                style={{
                  width: "100%",
                  marginLeft: "10px",
                }}
              >
                <DropZone
                  accept=".png,.jpeg,.jpg,.svg,.json"
                  //   type="file"
                  allowMultiple={false}
                  onDrop={handleDropZoneDrop}
                  onDropAccepted={sendImage}
                >
                  {uploadedFile}
                  {fileUpload}
                </DropZone>
              </div>
            </div>
          </FormLayout>
          {/* <FormLayout>
            <TextField
              label="Name"
              value={nameValue}
              onChange={handleChangeName}
            />
            <Autocomplete
              options={optionsLink}
              selected={selectedOptionsLink}
              onSelect={updateSelectionLink}
              textField={textFieldLink}
            />
            {selectedLinkType === "8" && (
              <Select
                label="Page"
                options={optionsPages}
                onChange={handleSelectChangePage}
                value={selectedPage}
                placeholder="Please select"
              />
            )}
            {selectedLinkType === "7" && (
              <TextField
                label="External Link"
                value={externalLinkValue}
                onChange={handleChangeExternalLink}
              />
            )}
          </FormLayout> */}
        </Card>
      </Modal>
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <p>Are you sure you want to delete this item?</p>
          </TextContainer>
        </Modal.Section>
      </Modal>
      <Modal
        open={activeChannels}
        onClose={handleChangeActiveChannels}
        title="Manage Channels"
        primaryAction={{
          content: "Done",
          onAction: handleChangeActiveChannelsDone,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: handleChangeActiveChannels,
          },
        ]}
      >
        <Modal.Section>
          <ChannelsModal
            channels={channels}
            handleSelectedChannels={handleSelectedChannels}
            selectedChannels={selectedChannels}
          />
        </Modal.Section>
      </Modal>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={[
          {
            content: "Delete",
            destructive: true,
            loading: isSaving && true,
            onClick: () => {
              setIsSaving(true);
              axios
                .delete(`/navigation-lists/${id}`)
                .then((result) => {
                  navigate(`/admin/navigation`);
                })
                .catch((err) => console.log(err));
            },
          },
        ]}
      />
      {toastMarkupToast}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    setIsSaving(true);
    const form_data = new FormData();
    form_data.append("title", item.title);
    form_data.append("is_active", 1);
    form_data.append("_method", "PATCH");
    selectedChannels && selectedChannels.length
      ? selectedChannels.forEach((selected, index) =>
          form_data.append(`channels[${index}]`, selected)
        )
      : form_data.append(`channels`, []);
    axios
      .post(`/navigation-lists/${id}`, form_data)
      .then((res) => {
        setToastContent("Changes have been saved successfully");
        toggleActiveToast();
        setIsSaving(false);
      })
      .catch((err) => console.log(""));
  }
  function findArrayElementByLanguage(array, language) {
    return array.find((element, index) => {
      return element.language === language;
    });
  }
  function findElementByID(array, id) {
    return array.find((element) => {
      return element.id === id;
    });
  }
};

export default EditMenu;
